import { Controller } from "@hotwired/stimulus";

export class DynamicListController extends Controller {
  static targets = ["input", "list", "hidden"];
  static values = {
    name: String,
  };

  connect() {
    this.syncFromHidden();
  }

  add() {
    const value = this.inputTarget.value.trim();
    if (!value) return;

    this.addItem(value);
    this.inputTarget.value = "";
    this.inputTarget.focus();
    this.updateHidden();
  }

  addItem(value, extra = null) {
    const li = document.createElement("li");
    li.className = "dynamic-list__item";
    li.dataset.value = value;
    if (extra) {
      Object.keys(extra).forEach((key) => {
        li.dataset[key] = extra[key];
      });
    }

    const textSpan = document.createElement("span");
    textSpan.className = "dynamic-list__text";
    textSpan.textContent = value;

    const actions = document.createElement("div");
    actions.className = "dynamic-list__actions";

    const removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "dynamic-list__btn-remove";
    removeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`;
    removeBtn.dataset.action = "click->dynamic-list#remove";

    actions.appendChild(removeBtn);
    li.appendChild(textSpan);
    li.appendChild(actions);
    this.listTarget.appendChild(li);
  }

  remove(event) {
    const item = event.currentTarget.closest(".dynamic-list__item");
    if (item) {
      item.remove();
      this.updateHidden();
    }
  }

  updateHidden() {
    const items = [];
    this.listTarget.querySelectorAll(".dynamic-list__item").forEach((li) => {
      const entry = { value: li.dataset.value };
      // Include any extra data attributes
      Object.keys(li.dataset).forEach((key) => {
        if (key !== "value") {
          entry[key] = li.dataset[key];
        }
      });
      items.push(entry);
    });
    this.hiddenTarget.value = JSON.stringify(items);
  }

  syncFromHidden() {
    const raw = this.hiddenTarget.value;
    if (!raw) return;
    try {
      const items = JSON.parse(raw);
      if (Array.isArray(items)) {
        this.listTarget.innerHTML = "";
        items.forEach((item) => {
          if (typeof item === "string") {
            this.addItem(item);
          } else if (item.value) {
            const extra = { ...item };
            delete extra.value;
            this.addItem(item.value, extra);
          }
        });
      }
    } catch {
      // Ignore malformed JSON
    }
  }
}
